module.exports = __webpack_public_path__ + "img/shop_light.f99fdd05.webp";